import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import './competencyList.css';
import { DomHelpers } from 'e4shared';
import { translateCompetency } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const CompetencyList = props => {
    const loaded = React.useRef(null);
    const { competencies, onClick, limit } = props;
    if (!competencies || competencies.length === 0) return null;
    const { user } = useSelector(state => state.user);
    const filteredCompetencies = competencies.filter(c => c !== null).map(c => translateCompetency(user.language_Code, c));

    const resizeHandler = () => {
        competencies &&
            (props.parent || loaded.current) &&
            DomHelpers.truncateText('ellipse', props.parent || loaded.current, 0);
    };

    React.useEffect(() => {
        resizeHandler();
    }, [competencies, props.parent, loaded.current]);

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    return (
        <div className="competency-list" ref={loaded}>
            {filteredCompetencies.map((c, i) => {
                if (i === limit) {
                    return (
                        <label key={i} className="label label-primary">
                            And {filteredCompetencies.length - limit} more....
                        </label>
                    );
                }
                if (limit && i > limit) return undefined;
                return (
                    <Link
                        title={`Search against ${c.area} - ${c.name}`}
                        onClick={event => {
                            event.stopPropagation();
                            onClick?.();
                        }}
                        key={c.id}
                        to={`/search?competency=${c.id}`}
                    >
                        <label key={i} className="label label-primary ellipse">
                            {`${c.area} - ${c.name}`}
                        </label>
                    </Link>
                );
            })}
            <div className="clear" />
        </div>
    );
};

export default withRouter(CompetencyList);
